import { DatePipe } from "@angular/common";
import {
  Component,
  EventEmitter,
  Input,
  OnInit,
  Output,
  TemplateRef,
  ViewChild,
} from "@angular/core";
import { FormControl } from "@angular/forms";
import { Store } from "@ngrx/store";
import { ToasterService } from "angular2-toaster";
import swal from "sweetalert2";
import * as fromRootStore from "../../../reducers";
import { GrnService } from "../../../services/grn.service";
import { Combo2Service } from "../../../services/index";
declare var google;

@Component({
  selector: "sample-swatch-grn",
  host: { "(window:keydown)": "hotkeys($event)" },
  templateUrl: "./sampleSwatchGrn.html",
})
export class sampleSwatchGrn implements OnInit {
  @Input("tabTitle") title: string;
  @Input("tabID") tabID: string;
  @Input("params") params: any;
  @Input() active = false;
  @Input() dataContext;
  @Output() tabUpdateEvent = new EventEmitter();

  redirect_to_invoice: boolean = false;
  seasonList = [];
  selected = [];
  grn_id: string;
  gridOptions: any;
  dataList = [];
  isLoadMask: Promise<any>;
  selectedDlrMapList: any[];
  loadingIndicator: boolean = true;
  reorderable: boolean = true;
  design_no: any;
  canGoInvoice : boolean = false;
  groupbyList = ["RETAIL", "WHOLESALE", "ESTIMATE"];
  filter = {
    party_code: "",
    design_no: "",
    pd_code: "",
    po_no: "",
    inv_ref: "",
    inv_no: "",
    grn_from_date: "",
    grn_to_date: "",
    finyear: "2019-2020",
  };
  page = {
    limit: 25,
    count: 0,
    offset: 0,
    orderBy: "grn_id",
    orderDir: "desc",
  };
  finyearList = [];
  agentList = [];
  seasonfinList = [];
  partyAgentList = [];
  partyList = [];

  @ViewChild("snoTemplate") snoTemplate: TemplateRef<any>;
  @ViewChild("nameTemplate") nameTemplate: TemplateRef<any>;
  @ViewChild("printTemplate") printTemplate: TemplateRef<any>;
  @ViewChild("editDeleteTemplate") editDeleteTemplate: TemplateRef<any>;
  @ViewChild("filterPanel") filterPanel;
  @ViewChild("partyDataTable") partyDataTable;

  finyearCtrl: FormControl = new FormControl();
  seasonCtrl: FormControl = new FormControl();
  agentCtrl: FormControl = new FormControl();
  partyCtrl: FormControl = new FormControl();
  groupCtrl: FormControl = new FormControl();
  columns = [];
  toggleCol = [];
  menu: any;
  data: any;
  reportName = "design_no";
  reportType = "Design";
  filterExpand = false;
  filterData: any;
  agentList$ = [];
  user: any;
  grnList: any;
  agentVisible: boolean = false;
  companyInfo: any = [];
  orderList: any = [];
  po_no: string;
  po_id: string;
  party_id : any;
  constructor(
    public store: Store<fromRootStore.State>,
    private grn: GrnService,
    public datePipe: DatePipe,
    private combo2Service: Combo2Service,
    public toasterService: ToasterService
  ) {}

  ngOnInit(): void {
    this.getColumns();
    this.toggleCol = Object.assign({}, this.columns);
    this.data = {
      grnList: [],
    };
  }

  hotkeys(event) {
    if (this.active) {
    }
  }

  getColumns() {
    this.columns = [
      {
        name: "SNo",
        prop: "sno",
        minWidth: 80,
        maxWidth: 80,
        width: 80,
        headerClass: "text-center",
        sortable: false,
        cellTemplate: this.snoTemplate,
        toggle: true,
        cellClass: "text-center",
      },
      {
        name: "Party Code",
        prop: "party_code",
        cellClass: "text-right",
        headerClass: "text-center",
        minWidth: 150,
        maxWidth: 150,
        width: 150,
      },
      {
        name: "Po No",
        prop: "po_no",
        cellClass: "text-right",
        headerClass: "text-center",
        minWidth: 80,
        maxWidth: 80,
        width: 80,
      },
      {
        name: "Inv No",
        prop: "inv_no",
        cellClass: "text-right",
        headerClass: "text-center",
        minWidth: 80,
        maxWidth: 80,
        width: 80,
      },
      {
        name: "Inv.Ref No",
        prop: "inv_ref_no",
        cellClass: "text-right",
        headerClass: "text-center",
        minWidth: 120,
        maxWidth: 120,
        width: 120,
      },
      {
        name: "Inv Date",
        prop: "inv_date_formatted",
        headerClass: "text-center",
        minWidth: 160,
        maxWidth: 160,
        width: 160,
      },
      {
        name: "GRN Date",
        prop: "grn_date_formatted",
        headerClass: "text-center",
        minWidth: 160,
        maxWidth: 160,
        width: 160,
      },
      {
        name: "GRN No",
        prop: "grn_no",
        cellClass: "text-right",
        headerClass: "text-center",
        minWidth: 80,
        maxWidth: 80,
        width: 80,
      },
      {
        name: "LR No",
        prop: "lr_no",
        cellClass: "text-right",
        headerClass: "text-center",
        minWidth: 80,
        maxWidth: 80,
        width: 80,
      },
      //  {name: 'RC No',prop: 'rc_no',cellClass: 'text-right', minWidth: 80,maxWidth: 80,width: 80 },
      {
        name: "Barcode",
        prop: "barcode",
        cellClass: "text-center",
        headerClass: "text-center",
        minWidth: 80,
        maxWidth: 80,
        width: 80,
        cellTemplate: this.printTemplate,
      },
      {
        name: "Action",
        prop: "sno",
        minWidth: 130,
        maxWidth: 130,
        headerClass: "text-center",
        width: 130,
        sortable: false,
        cellTemplate: this.editDeleteTemplate,
      },
    ];

    if (this.menu.param == "pending") {
      let splitBit = {
        prop: "selected",
        name: "",
        sortable: false,
        canAutoResize: false,
        draggable: false,
        resizable: false,
        headerCheckboxable: true,
        checkboxable: true,
        width: 30,
      };
      this.columns.splice(0, 0, splitBit);

      this.redirect_to_invoice = true;
    }

    this.toggleCol = Object.assign({}, this.columns);
    this.finyearCombo();
  }

  onOpenedFilter(): void {
    setTimeout(function () {
      $("#party_code").focus();
    }, 100);
  }

  onChangePageSize(limit) {
    this.page.limit = 10000;
    //this.getSalesinvReport();
  }

  onColumnToggle(colToShow) {
    this.columns = colToShow;
  }

  onEnterKeyPressed(nextEl: string, ind, item) {
    if ($(".swal2-container").length > 0) {
      return false;
    } else {
      let a = $(".mat-autocomplete-panel.mat-autocomplete-visible");
      a.removeClass("mat-autocomplete-visible");
      $("#" + nextEl).focus();
    }
  }

  getRowClass(event) {
    return event.rowtype == "summary" ? "summary-row" : "";
  }
  finyearCombo() {
    let that = this;
    this.combo2Service.finyearCombo().then((res: any) => {
      that.finyearList = res.data;
      that.filter.finyear = res.data[0].finyear;
      const oneMonthAgo = new Date();
      oneMonthAgo.setMonth(oneMonthAgo.getMonth() - 1);
      that.filter.grn_from_date = oneMonthAgo as any;
      that.pageCallback({ offset: 0 });
    });
  }
  /**
   * Called whenever the user changes page
   */
  pageCallback(pageInfo: {
    count?: number;
    pageSize?: number;
    limit?: number;
    offset?: number;
  }) {
    this.page.offset = pageInfo.offset;
    this.getGrnList();
  }

  /**
   * Called whenever the user changes the sort order
   */
  sortCallback(sortInfo: {
    sorts: { dir: string; prop: string }[];
    column: {};
    prevValue: string;
    newValue: string;
  }) {
    // there will always be one "sort" object if "sortType" is set to "single"
    this.page.orderDir = sortInfo.sorts[0].dir;
    this.page.orderBy = sortInfo.sorts[0].prop;
    // this.getSalesinvReport();
  }

  clearFilter(): void {
    this.filter.party_code = "";
    this.filter.pd_code = "";
    this.filter.po_no = "";
    this.filter.inv_no = "";
    this.filter.inv_ref = "";
    const oneMonthAgo = new Date();
    oneMonthAgo.setMonth(oneMonthAgo.getMonth() - 1);
    this.filter.grn_from_date = oneMonthAgo as any;
    this.filter.grn_to_date = "";
    this.filter.design_no = "";
    this.applyFilter();
  }

  applyFilter(): void {
    //this.filterExpand = false;
    this.filterPanel.close();
    this.getGrnList();
  }

  loadSeasonList() {
    let that = this;
    this.combo2Service.seasonCombo().then(function (res) {
      //  this.LoadAgentList();
      that.seasonList = res.data;
      that.seasonCtrl.setValue(res.data[0].season_id);
    });
  }

  addEditGrn(mode: string, row: any): void {
    this.filterExpand = true;
    let listUpdateEvent = new EventEmitter();
    listUpdateEvent.subscribe(() => {
      this.filterExpand = true;
      this.getGrnList();
    });
    row.tabevent = listUpdateEvent;
    let tabObj = {};
    if (mode == "Add") {
      tabObj = {
        action: "NewTab",
        params: {
          //  tabParent: 'Transaction',
          tabName: "ADD SAMPLE/SWATCH GRN",
          title: "ADD SAMPLE/SWATCH GRN",
          tabParent: "CLOTH",
          mode: mode,
          data: row,
          name: "addEditSampleSwatchGrn",
        },
      };
    } else if (mode == "Edit") {
      tabObj = {
        action: "NewTab",
        params: {
          //   tabParent: 'Transaction',
          tabName: "EDIT SAMPLE/SWATCH GRN",
          title: "EDIT SAMPLE/SWATCH GRN",
          tabParent: "CLOTH",
          mode: mode,
          data: row,
          name: "addEditSampleSwatchGrn",
        },
      };
    } else if (mode == "View") {
      tabObj = {
        action: "NewTab",
        params: {
          //   tabParent: 'Transaction',
          tabName: "VIEW SAMPLE/SWATCH GRN",
          title: "VIEW SAMPLE/SWATCH GRN",
          tabParent: "CLOTH",
          mode: mode,
          data: row,
          name: "addEditSampleSwatchGrn",
        },
      };
    }

    this.tabUpdateEvent.emit(tabObj);
  }
  getGrnList(): void {
    if (this.filter.grn_from_date == "") {
      this.filter.grn_from_date == "";
    } else {
      this.filter.grn_from_date = this.datePipe.transform(
        this.filter.grn_from_date,
        "yyyy-MM-dd"
      );
    }
    if (this.filter.grn_to_date == "") {
      this.filter.grn_to_date == "";
    } else {
      this.filter.grn_to_date = this.datePipe.transform(
        this.filter.grn_to_date,
        "yyyy-MM-dd"
      );
    }
    let params = {
      start: `${this.page.offset * (this.page.limit + 1)}`,
      limit: `${this.page.limit}`,
      page: "1",
      orderColumn: `${this.page.orderBy}`,
      orderDir: `${this.page.orderDir}`,
      party_code: this.filter.party_code,
      po_no: this.filter.po_no,
      inv_ref: this.filter.inv_ref,
      inv_no: this.filter.inv_no,
      grn_from_date: this.filter.grn_from_date,
      grn_to_date: this.filter.grn_to_date,
      finyear: this.filter.finyear,
      pd_code: this.filter.pd_code,
      design_no: this.filter.design_no,
      type: this.menu.param,
      grn_list_type: "SAMPLE-SWATCH",
    };
    let that = this;
    //this.store.dispatch(new commonActions.LoadAllParty(params));
    this.isLoadMask = this.grn.getGrnList(params).then(function (res: any) {
      that.loadingIndicator = false;
      that.page.count = res.totCnt;
      that.grnList = res.data;
    });
  }

  deleteGrn(row: any): void {
    let that = this;
    row["tabevent"] = undefined;
    swal({
      title: "Are you sure to delete this Grn Details?",
      text:
        "You will not be able to recover this Grn" + " " + row["grn_no"] + "",
      type: "warning",
      showCancelButton: true,
      confirmButtonText: "Yes, delete it!",
      cancelButtonText: "No, keep it",
    }).then(
      function () {
        that.isLoadMask = that.grn.deleteGrn(row).then(function (res: any) {
          that.loadingIndicator = false;
          that.getGrnList();
          let errtype = "success",
            errmsg = res.message;
          if (!res.success) {
            errtype = "error";
          }

          that.toasterService.pop({
            bodyOutputType: 1,
            type: errtype,
            title: errtype.toUpperCase(),
            body: errmsg,
          });
        });
      },
      function (dismiss) {}
    );
  }

  loadeditgrnlist(row) {
    let params = {
      grn_id: row.grn_id,
    };
    this.grn.getEditGrnList(params).then((res: any) => {
      this.clickPrint(row, res.data);
      this.data.grnList = res.data;
      this.design_no = res.design_no - 1;
    });
  }

  clickPrint(row, data) {
    let that = this;
    let params: any = Object.assign({}, row);
    params["data"] = JSON.stringify(data);
    that.isLoadMask = that.grn.grnprint(params).then(function (res: any) {});
  }

  async canOpenInvoice() {
    let params = {
      grn_id: this.grn_id,
    };
    let canOpen = false;
    let that = this;
    await that.grn
      .checkNonOrderExists(params)
      .then((res: any) => {
        if (res.success) {
          canOpen = true;
        } else {
          swal(
            "Selected GRN " + res.grn_no + " has non-ordered designs.Please accept or return the goods and proceed"
          );
          return;
        }
      })
      .catch(() => {
        canOpen = false;
      });
    return canOpen;
  }
  getId(row) {
    return row.grn_id;
  }
  getIdFunction() {
    return this.getId.bind(this);
  }
  onSelect({ selected }) {
    this.selected.splice(0, this.selected.length);
    console.log(this.selected);

    this.selected.push(...selected);
    this.grn_id = "";
    this.grn_id = this.selected.map((el) => el.grn_id).toString();
    // this.po_no = this.selected.map((el) => el.po_no).toString();
    this.po_no  = this.selected.map(item => item.po_no).filter((value, index, self) => self.indexOf(value) === index).toString();
    this.po_id  = this.selected.map(item => item.po_id).filter((value, index, self) => self.indexOf(value) === index).toString();
    this.party_id  = this.selected.map(item => item.party_id).filter((value, index, self) => self.indexOf(value) === index);

    if(this.party_id.length > 1 ){
      this.canGoInvoice = true;
      swal("Please select same party");
      return;
    }else{
      this.canGoInvoice = false;
    }
  }
  openInvoiceScreen() {

    this.canOpenInvoice().then((res) => {
      if(res){
        if(this.selected.length > 0){
          this.filterExpand = true;
          let listUpdateEvent = new EventEmitter();
          this.getGrnList();
           // let row = Object.assign({}, this.selected[0]);
          let row = {
            grn_id: this.grn_id,
            po_no: this.po_no,
            po_id: this.po_id,
            tabevent: listUpdateEvent
          };
          let tabObj = {
            action: "NewTab",
            params: {
              //  tabParent: 'Transaction',
              tabName: "ADD COURIER PURCHASE INVOICE",
              title: "ADD PURCHASE INVOICE",
              tabParent: "CLOTH",
              mode: "SAMPLE GRN",
              data: row,
              name: "PurchaseInvoiceComponent",
            },
          };
          this.tabUpdateEvent.emit(tabObj);
        }else{
          swal("Please select atleast one GRN");
        }
      }
    });
    
    
  }
}



// WEBPACK FOOTER //
// /Users/afsarahamed/Documents/symatis/projects/hyatt-angularweb/src/app/components/Purchase/grn/sampleSwatchGrn.ts